<template>
	<v-card>
		<v-form class="text-xs-left">
			<v-toolbar flat dense>
				<v-toolbar-title class="subheading">{{ title }}</v-toolbar-title>
				<v-spacer></v-spacer>
			</v-toolbar>
			<v-container>
				<v-text-field ref="name" v-model="$v.form.name.$model" label="Category Name" :error-messages="errorsName" required />

				<v-text-field v-model="form.assetNoPrefix" @input="transformAssetPrefix" label="Asset Prefix (optional)" persistent-hint hint="Auto-generated asset IDs will begin with the specified prefix. E.g., 'CAR'. Please note: a hyphen will automatically be appended to the prefix." class="mb-2" />
				<v-alert v-if="shouldShowPrefixAlert" :value="true" type="warning" outline class="mb-4">Updating the category prefix will not update existing asset numbers.</v-alert>

				<v-textarea v-model="form.description" label="Description" auto-grow rows="1"></v-textarea>
			</v-container>

			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn flat @click="closeEditor">Cancel</v-btn>
				<v-btn class="primary" @click="onUpsertClick" :disabled="isSaving" flat>
					Save
				</v-btn>
			</v-card-actions>
		</v-form>
	</v-card>
</template>

<script>
	import { validationMixin } from 'vuelidate';
	import { required } from 'vuelidate/lib/validators';

	export default {
		name: 'AssetCategoryEditor',
		props: {
			// Pass in a form to edit. Otherwise, it will be all new values
			category: {
				type: Object,
				default: undefined
			},
			isSaving: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				form: {
					name: '',
					description: '',
					assetNoPrefix: ''
				}
			};
		},
		mounted() {
			this.$nextTick(() => {
				this.$refs.name.focus();
			});
		},
		computed: {
			isNewCategory() {
				return !!!this.category;
			},
			errorsName() {
				if (!this.$v.form.name.$dirty || !this.$v.form.name.$error) return [];
				return ['Name is required.'];
			},
			shouldShowPrefixAlert() {
				return this.category && this.form.assetNoPrefix !== this.category.assetNoPrefix;
			},
			title() {
				return this.isNewCategory ? 'New Category' : 'Edit Category';
			}
		},
		watch: {
			category() {
				this.populateForm();
			}
		},
		methods: {
			transformAssetPrefix() {
				this.form.assetNoPrefix = this.form.assetNoPrefix.toUpperCase();
			},
			clear() {
				this.$v.$reset();
				this.populateForm();
			},
			populateForm() {
				if (this.category) {
					this.form = { ...this.category };
				} else {
					this.form.name = '';
					this.form.description = '';
					this.form.assetNoPrefix = '';
				}
			},
			onUpsertClick() {
				this.$v.$touch();
				if (!this.$v.$invalid) {
					const filledForm = {
						...this.form,
						id: this.category ? this.category.id : null
					};
					this.$emit('onSave', filledForm);
				}
			},
			closeEditor() {
				this.clear();
				this.$emit('closeEditor');
			}
		},
		created() {
			this.clear();
		},
		mixins: [validationMixin],
		validations: {
			form: {
				name: { required }
			}
		}
	};
</script>
